window.copyToClipboard = function(value) {
    let $temp = $("<textarea></textarea>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();
};
